import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { TouristsList } from "../../../../Tourists"

export default function OrganizationTouristsPage() {
	return (
		<>
			<Helmet>
				<title>Tourists</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<TouristsList />
			</ForbidUnlessAuthorized>
		</>
	)
}
